import { DB_ID, db, USERS_TABLE_ID, id, query } from "@/appwrite";
import { toEmployee } from "@/helpers/dbHelpers";
import { Employee, HookResponse, ProjectModel } from "@models/Models";

const useEmployee = () => {

    const createEmployee = async (newEmployee: Partial<Employee>) => {
        try {
            const result = await db.createRow({
                databaseId: DB_ID,
                tableId: USERS_TABLE_ID,
                rowId: id.unique(),
                data: newEmployee
            })

            if(!result) {
                return {
                    success: false,
                    message: 'Failed to create employee',
                    data: null
                }
            }

            return {
                success: true,
                message: "Successfully created employee",
                data: result
            }

        }catch(error: any) {
            console.error('Error creating employee:', error);
            return {
                success: false,
                message: error.message,
                data: null
            }
        }
    };

    const getAllEmployees = async () => {
        try {
            const result = await db.listRows({ 
                databaseId: DB_ID, 
                tableId: USERS_TABLE_ID,
                queries: [
                    query.select([
                        "*",
                    ]),
                ] 
            });

            const employees = result.rows.map((doc) => toEmployee(doc));
    
            return {
                success: true,
                message: 'Successfully fetched employees',
                data: employees
            };
        } catch (error: any) {
            console.error('Error getting all employees:', error);
            return {
                success: false,
                message: error.message,
                data: null
            };
        }
    };

    const getEmployeeById = async (employeeId: string): Promise<HookResponse> => {
        try {
            const result = await db.getRow({
                databaseId: DB_ID,
                tableId: USERS_TABLE_ID,
                rowId: employeeId
            });

            if(!result) {
                return {
                    success: false,
                    message: 'Failed to get employee',
                    data: null
                }
            }

            const myEmployee = toEmployee(result);

            return {
                success: true,
                message: "Successfully fetched employee",
                data: myEmployee
            }

        } catch(error: any) {
            console.error('Error getting employee by id:', error);
            return {
                success: false,
                message: error.message,
                data: null
            }
        }
    };

    const updateEmployee = async (employeeId: string, updatedEmployee: Partial<Employee>) => {
        try {
            const result = await db.updateRow({
                databaseId: DB_ID,
                tableId: USERS_TABLE_ID,
                rowId: employeeId,
                data: updatedEmployee
            });

            if(!result) {
                return {
                    success: false,
                    message: 'Failed to update employee',
                    data: null
                }
            }

            return {
                success: true,
                message: "Successfully updated employee",
                data: result
            }
        }catch (error: any) {
            console.error('Error updating employee:', error);
            return {
                success: false,
                message: error.message,
                data: null
            }
        }
    };

    const deleteEmployee = async (employeeId: string) => {
        try {
            const result = await db.deleteRow({
                databaseId: DB_ID,
                tableId: USERS_TABLE_ID,
                rowId: employeeId
            });

            if(!result) {
                return {
                    success: false,
                    message: 'Failed to delete employee',
                    data: null
                }
            }

            return {
                success: true,
                message: "Successfully deleted employee",
                data: null
            }
        } catch(error: any) {
            console.error('Error deleting employee:', error);
            return {
                success: false,
                message: error.message,
                data: null
            }
        }
    }

    return {
        createEmployee,
        getAllEmployees,
        getEmployeeById,
        updateEmployee,
        deleteEmployee,
    }
};

export default useEmployee;